import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

export function ReturnBlack(props: any) {
  return (
    <Svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1095_23192)">
        <Path
          d="M1.043 30.843h16.075c7.869 0 14.246-5.578 14.246-12.459 0-6.881-6.378-12.46-14.246-12.46h-7.36"
          stroke="#251F2C"
          strokeWidth={3}
          strokeMiterlimit={10}
        />
        <Path d="M.5 5.783l9.84 5.783V0L.5 5.783z" fill="#251F2C" />
      </G>
      <Defs>
        <ClipPath id="clip0_1095_23192">
          <Path
            fill="#fff"
            transform="matrix(1 0 0 -1 .5 32)"
            d="M0 0H32V32H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
